<div class="table-container" [ngClass]="{ 'half-screen': selectedUser }">
  <app-list-header
    [title]="title"
    [searchPlaceholder]="'users.search' | translate"
    [searchTerm]="searchTerm | async"
    (searchTermChange)="searchTerm.next($event); searchUsers()"
    (clearSearch)="clearFilter()"
    (addNewItem)="createNewUser()"
  ></app-list-header>

  <table class="table">
    <thead>
      <tr>
        <th class="name-header">
      
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let user of filteredUsers | async"
        (click)="select(user)"
        [class.selected]="user === selectedUser"
      >
        <td>{{ user.displayname }}</td>
      </tr>
    </tbody>
  </table>
</div>
